module.exports = "/assets/data/8c1c19aed3c82c04cd0847c9ea121bcd-DG3.data.json";